import { useTranslations } from "next-intl";
import { useState } from "react";

import UI from "./UI";

type Props = {
  id: string;
};

const WishlistToggle = ({ id }: Props) => {
  const t = useTranslations();
  const addToWishlistText = t("saveToFavourites");
  const removeFromWishlistText = t("removeFromFavourites");

  const [wishlistText, setWishlistText] = useState(addToWishlistText);

  const toggleText = (inWishlist: boolean) => {
    setWishlistText(inWishlist ? removeFromWishlistText : addToWishlistText);
  };
  return <UI id={id} wishlistText={wishlistText} toggleText={toggleText} />;
};

export default WishlistToggle;
